<template>
    <button class="btn editBtn" @click.prevent="copyLink">
        <img width="48" height="48" :src="linkImg" />
    </button>
</template>


<script setup>
import linkImg from '@/assets/img/white-share-icon.png'
import Swal from 'sweetalert2'
const copyLink = () => {
    try {
        navigator.clipboard.writeText(window.location.href)
        Swal.fire({
            title: 'Link copied to clipboard',
            icon: 'success',
            timer: 1500,
            toast: true,
            showConfirmButton: false,
        })
    } catch (error) {
        console.error('Failed to copy link', error)
        Swal.fire({
            title: 'Failed to copy link',
            icon: 'error',
            timer: 1500,
            toast: true,
        })
    }
}

</script>